import script from "./ProductCustomizerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCustomizerModal.vue?vue&type=script&setup=true&lang=js"

import "./ProductCustomizerModal.vue?vue&type=style&index=0&id=17dae6f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17dae6f4"]])

export default __exports__